// eslint-disable-next-line
export const appName = (function() {
  // 方便测试
  if (localStorage.getItem('debug_mock_kwai')) {
      return 'kwai';
  }
  const ua = navigator.userAgent;
  const appRules: any = {
      qq: /\bQQ\b/,
      // 快手app 安卓：ksNebula ios：ksnebula
      kwai: / (Kwai|Kwai_Lite|Kwai_Pro|livemate|ksthanos|ksNebula|ksnebula|kswv)\//,
      wechat: /\bMicroMessenger\b/,
      weibo: /\bWeibo\b/,
      qzone: /\bQzone\b/,
      // 腾讯浏览服务(Tencent Browser Service) 简称TBS
      // tbs: /\bTBS\b/,
      // 手机QQ浏览器
      // qqBrowser: /\bMQQBrowser\b/,
      // 手机百度
      baidu: /\bbaiduboxapp\b/,
      uc: /\bUCBrowser\b/,
  };
  /**
   * 获取当前所在 app名
   * return 'wechat' || 'kwai' || 'qq' ...
   */
  function getAppName() {
      for (const key in appRules) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          const rule = appRules[key];
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          if (rule.test(ua)) {
              return key;
          }
      }
      return 'unknow';
  }
  return getAppName();
})();
/**
* 是否在快手
* 可以被moke localStorage debug_mock_kwai
*/
const UA = navigator.userAgent;

export const isInWechat = appName === 'wechat';
export const isInWeibo = appName === 'isInWeibo';
export const isInKwai = appName === 'kwai';
export const isInIOS = /iPhone|iPad|iPod|iOS/i.test(UA);
export const isAndroid = /android/i.test(UA);
